import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { apiFetch } from '../../auth/paymentsApi';
import { orderText } from './orderManagementText';
import '../../pages/WeeklyIncomeSettings.css';
const money = (cents, currency) => `${(cents / 100).toFixed(2)} ${currency}`;
export default function PendingCheckoutResume() {
  const [data, setData] = useState(null), [error, setError] = useState('');
  useEffect(() => { let active = true; apiFetch('/orders/pending-checkout').then(value => { if (active) setData(value); }).catch(e => { if (active) setError(e.message); }); return () => { active = false; }; }, []);
  if (error) return <p role="alert">{error}</p>;
  if (!data) return <p role="status">{orderText('processing')}</p>;
  const { payload, texts } = data;
  return <section className="wie" style={{ maxWidth: 1100, margin: '24px auto', padding: 20 }}>
    <h2>{texts.details}</h2>
    <p>{texts.pendingSummary.replace('{{pendingOrderCount}}', payload.pendingOrderCount)}</p>
    {!payload.pendingOrderCount && <Link to="/c/orders">{texts.order}</Link>}
    {payload.orders.map(order => <article key={order.orderId} className="wie-card">
      <h3>{texts.order}: {order.orderRef}</h3><p className="wie-hint">{texts.date}: {new Date(order.createdAt).toLocaleString()}</p>
      {order.items.map(item => <div key={item.lineId} style={{ display: 'flex', flexWrap: 'wrap', gap: 16, marginTop: 16, alignItems: 'center' }}>
        {item.imageUrl && <img src={item.imageUrl} alt={item.productName} width={64} style={{ height: 64, objectFit: 'contain' }} />}
        <div style={{ flex: '1 1 220px' }}><strong>{item.productName || item.productId}</strong>{item.variant && <p>{item.variant}</p>}<p>{texts.quantity}: {item.quantity} · {texts.total}: {money(item.amountCents, item.currency)}</p></div>
        <Link className="wie-btn wie-btn--primary" to={`${new URL(item.checkoutUrl).pathname}${new URL(item.checkoutUrl).search}`}>{texts.details}</Link>
      </div>)}
    </article>)}
    {!!payload.pendingOrderCount && <div className="wie-card"><strong>{texts.total}: {payload.totals.map(total => money(total.amountCents, total.currency)).join(' + ')}</strong></div>}
  </section>;
}
